import connect from 'react-redux/es/connect/connect';

import ActivityCardPage from './ActivityCardPage';
import {
    addActivityToCompareList,
    clearCompareList,
    removeActivityFromCompareList
} from '../../actions/compareActivities';

const mapStateToProps = state => ({
    compareActivities: state.compareActivities,
    isAgent: state.user.user?.role === 'agent',
    isAdmin: state.user.user?.role === 'admin',
    customerData: state.user.customer
});

const mapDispatchToProps = dispatch => ({
    addActivityToCompareList: activity => {
        dispatch(addActivityToCompareList(activity));
    },
    removeActivityFromCompareList: activityId => {
        dispatch(removeActivityFromCompareList(activityId));
    },
    clearCompareList: () => {
        dispatch(clearCompareList());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityCardPage);
